var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77679 0.5C1.52221 0.5 1.27823 0.554166 1.04486 0.662497C0.811494 0.770828 0.609947 0.922492 0.440223 1.11749C0.2705 1.31248 0.15381 1.53998 0.0795562 1.78914C0.00530209 2.0383 -0.0159108 2.2983 0.0159124 2.54746C1.10851 11.2356 1.10851 10.7698 0.0159124 19.4471C-0.0265185 19.7613 0.0159072 20.0863 0.1432 20.3788C0.259885 20.6713 0.461439 20.9313 0.705417 21.1263C0.949395 21.3213 1.24641 21.4404 1.55403 21.4838C1.86165 21.5271 2.17989 21.4837 2.4663 21.3538L22.9074 12.6656C23.2362 12.5248 23.512 12.2973 23.703 11.9939C23.8939 11.6906 24 11.344 24 10.9865C24 10.629 23.8939 10.2715 23.703 9.97898C23.512 9.67565 23.2256 9.44816 22.9074 9.30733L2.4663 0.640831C2.24353 0.543332 2.01017 0.5 1.76619 0.5H1.77679Z",
    fill: "#006EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.8cc9136c7a98b4e5471259b0fd8244f0.svg";
export { ForwardRef as ReactComponent };